import DOMPurify from 'dompurify';
import { useState } from 'react';

import { MinimalCode } from '@/components/Code/MinimalCode';
import { Button, Text } from '@/design-system';

import CodeHeader from '../../../components/CodeHeader';

export const PlaygroundOutputCodeBlock = ({
  code,
  language,
}: {
  code: string;
  language: string;
}) => {
  const isHtml = language.toLowerCase() === 'html';
  const [renderHtml, setRenderHtml] = useState(false);

  const toggleRenderHtml = () => {
    setRenderHtml((prevState) => !prevState);
  };

  const headerText = (
    <div className="flex items-center gap-3">
      <Text>{language}</Text>
      {isHtml && (
        <Button size="sm" onClick={toggleRenderHtml}>
          {renderHtml ? 'Show Code' : 'Render HTML'}
        </Button>
      )}
    </div>
  );

  const supportsTrustedTypes = typeof window.trustedTypes !== 'undefined';

  return (
    <div className="rounded-lg border border-secondary bg-background pb-1">
      <div className="px-3.5 py-1.5">
        <CodeHeader
          textSx={{ fontSize: '14px' }}
          sx={{ marginBottom: '0px' }}
          text={headerText}
          copy={code}
          useIconCopyButton
        />
      </div>
      <div
        className={`mx-2 rounded rounded-b-lg ${
          isHtml && renderHtml ? 'bg-white p-3.5 text-black' : 'bg-background'
        }`}
      >
        {isHtml && renderHtml ? (
          <div
            className="prose whitespace-normal"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(code, {
                RETURN_TRUSTED_TYPE: supportsTrustedTypes,
              }),
            }}
          />
        ) : (
          <MinimalCode code={code} language={language} />
        )}
      </div>
    </div>
  );
};
